import { render, staticRenderFns } from "./LibraryStaff.vue?vue&type=template&id=67995ed4&"
import script from "./LibraryStaff.vue?vue&type=script&lang=js&"
export * from "./LibraryStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports